<button tabindex="1"
  class="econ-help-button"
  matTooltip="click for graph instructions"
  (click)="openDialog()"
>
  <mat-icon aria-hidden="false" aria-label="Graph instructions" color="accent"
    >info</mat-icon>
</button>
